module.exports = __webpack_public_path__ + "img/map.2e0b6ff0.jpg";